import axios from "axios";

import CoreService from "./core.service";


export const getUser = (token) => axios.get(`${CoreService.getPublicURL()}getUser?activation=` + token);

export const resetPassword = (email) => {
  return axios.get(`${CoreService.getPublicURL()}resetPassword?email=` + email);
};
export const registerComplete = (data) => {
  return axios.post(`${CoreService.getPublicURL()}register`, data);
};
export const confirmResetPassword = (data) => {
  return axios.post(`${CoreService.getPublicURL()}resetPassword`, data);
};
export const login = (username, password) => {
  eraseCookie("Authorization");

  return axios.post(
    `${CoreService.getPublicURL()}login`,
    {
      username: username,
      password: password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const logout = () => {
  const token = localStorage.getItem("Authentication");

  if (token) {
    axios.post(
    `${CoreService.getPrivateURL()}users/logout`,
    {},
    { withCredentials: true, headers: { Authorization: token } }
    ).then(r => console.log(r.data)).catch(() => {}) ;
  }

  localStorage.clear();

  eraseCookie("Authorization");
  localStorage.setItem("second_load2", "1");
  const domainSuffix = isLocalhost() ? "" : ";domain=.amenitybooking.ca";
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/" + domainSuffix);
  });
};


export const doLogout = () => {
  logout();
  window.location.reload();
};
 

export const getUserRole = () => localStorage.getItem("permission") || "";
export const getCurrentInstanceId = () => localStorage.getItem("instance_id") || 1;
export const getUserNickName = () => localStorage.getItem("nick_name") || "John Doe";
export const getUserFirstName = () => localStorage.getItem("first_name") || "John";
export const getUserLastName = () => localStorage.getItem("last_name") || "Doe";
export const getUserUnit = () => localStorage.getItem("unit") || "1234";
export const getUserEmail = () => localStorage.getItem("email") || "12345@gmail.com";
export const getClientName = () => localStorage.getItem("client") || "North Building";
export const getBuildingName = () => localStorage.getItem("building") || "";
export const getUserAvatar = () => localStorage.getItem("avatar");
export const getCurrentInstanceName = () => localStorage.getItem("instance_name") || "AAIS";
export const getCurrentInstanceLogo = () =>
  localStorage.getItem("instance_logo") ||
  CoreService.BASE_API_URL + "statics/" + window.location.hostname.split(".")[0] + "/instances/AB_Logo.png";

export const getUserIsLogin = () => {
  const permission = localStorage.getItem("permission");

  // console.log("getUserIsLogin()");
  // console.log("permission:", permission);

  if (permission) {
    //console.log(" LOGIN TRUE");
    return true;
  } else {
    //console.log(" LOGIN FALSE");
    return false;
  }
};


function isLocalhost() {
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h.endsWith(".localhost");
}

function eraseCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/`;

  document.cookie = `${name}=; Max-Age=0; path=/; domain=.amenitybooking.ca`;
}

export const changeLocalAvatar = (avatar) => localStorage.setItem("avatar", CoreService.BASE_API_URL + avatar)

const AuthService = {
  login,
  logout,
  getUserNickName,
  getClientName,
  getBuildingName,
  getUserAvatar,
  getUserRole,
  getUserIsLogin,
  changeLocalAvatar,
  getUser,
  registerComplete,
  resetPassword,
  confirmResetPassword,
};
export default AuthService;
